import { useContext } from "react";
import {
  Box,
  Paper,
  Typography,
} from "@mui/material";
import { BsChatRightTextFill } from "react-icons/bs";
import { AssistenciasContext } from "../../contexts/assistencias-context";
import "react-datepicker/dist/react-datepicker.css";
import AssistenciaComentarios from "./assistencia-comentarios";

export default function AssistenciaTabComentarios() {

  const {
    constantes,
  } = useContext(AssistenciasContext);

  return (
    <Box component={Paper}>
      <Box
        display="flex"
        alignItems="center"
        p={2}
        height={50}
        sx={{ backgroundColor: "rgba(59, 134, 124, 0.08)" }}
      >
        <Typography variant="h1" fontSize={22} fontWeight="sembold">
           <BsChatRightTextFill size={22} style={{ marginBottom: "5px", marginRight: "8px" }} />
            {constantes.Comentarios}
        </Typography>
      </Box>

      <AssistenciaComentarios/>
              
  </Box>
  );
}

